import { ApiSchema } from "@api-types";
import { combineLatest, of } from "rxjs";
import { filter, map } from "rxjs";
import { getUserService } from "services/user.service";

export const hasPolicy$ = (policy: ApiSchema.Policy) =>
  getUserService().policies$.pipe(
    map((policies) => policies.includes(policy)),
    filter((e) => typeof e === "boolean"),
  );
